import { EuiComboBox, EuiComboBoxOptionOption, EuiFlexGroup, EuiFormLabel } from '@elastic/eui';
import { useIntl } from 'react-intl';
import { isPictureAvailable } from 'cache';
import { useLocalCache } from 'hooks/useLocalCache';

import * as S from './FiltersSidebar.styles';

export const PictureAvailableFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const localFilters = useLocalCache();

  const getCurrentOption = (selected?: boolean | null): { label: string; value?: boolean } => {
    if (typeof selected === 'undefined') return { label: 'Tutti' };
    if (selected === true) return { label: 'Con foto', value: selected };
    if (selected === false) return { label: 'Senza foto', value: selected };
    return { label: 'Tutti' };
  };

  return (
    <S.SidebarFilterWrapper>
      <EuiFlexGroup direction="column">
        <EuiFormLabel style={{ marginRight: '10px' }}>
          {formatMessage({ id: 'filters.isPictureAvailable.label' })}
        </EuiFormLabel>
        <EuiComboBox
          aria-label="Accessible screen reader label"
          placeholder="Select a single option"
          isClearable={false}
          singleSelection={{ asPlainText: true }}
          options={[
            { label: 'Con foto', value: true },
            { label: 'Senza foto', value: false },
            { label: 'Tutti', value: undefined },
          ]}
          selectedOptions={[
            getCurrentOption(localFilters?.data?.isPictureAvailable) as EuiComboBoxOptionOption<boolean | null>,
          ]}
          onChange={(x): void => {
            isPictureAvailable(x[0]?.value);
          }}
        />
      </EuiFlexGroup>
    </S.SidebarFilterWrapper>
  );
};
